
.AutoCompleter:global(.form-control) {
    position: relative;
    padding: 2px;
}

.AutoCompleter:global(.form-control) > input {
    border: 0;
    width: 100%;
    padding: 0.375rem 0.75rem;
}

.AutoCompleter:global(.form-control) > input:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.AutoResults {
    position: absolute;
    margin-top: -1px;
    background-color: var(--bs-body-bg);
    width: 100%;
    border: 1px solid var(--bs-border-color);
    border-bottom-left-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    z-index: 5;
  }
  